import { Route } from 'react-router-dom';
import { ErrorBoundaryRoute } from '@hotjar/webapp-routing';
import { ENGAGE_INSIGHTS } from '@hotjar/webapp/constants/routes';
import { RedirectWithCurrentParams } from '@hotjar/webapp/utils/routing';
import { EngageInsights } from '@hotjar/engage-insights-mfe';

const EngageResearchList = () => {
  return (
    <ErrorBoundaryRoute squadSentryTag="engage" featureName="engage-insights.list">
      <EngageInsights />
    </ErrorBoundaryRoute>
  );
};

export const EngageInsightsRoutes = (): JSX.Element => {
  return (
    <>
      <Route
        path={ENGAGE_INSIGHTS.BASE.path}
        element={<RedirectWithCurrentParams to={ENGAGE_INSIGHTS.LIST.path} />}
      />

      <Route path={ENGAGE_INSIGHTS.LIST.path} element={<EngageResearchList />} />
    </>
  );
};
